import { EyeIcon } from "@heroicons/react/24/outline";
import { createPortal } from "react-dom";

import { GridInputs } from "../../../../../../../components/Functional";
import useTooltip from "../../../../../../../hooks/useTooltip";
import { formatCurrency } from "../../../../../../../util";

const Total = props => {
  const { formik } = props;
  const { balance30Days = null, balance60Days = null } =
    formik?.values?.invoiceTotals || {};
  const { showTooltip, tooltipPos, handleMouseEnter, handleMouseLeave } =
    useTooltip({ offsetTop: 5, hideDelay: 50 });

  const inputs = {
    className: "my-8 grid grid-cols-1 gap-4 lg:grid-cols-4 lg:gap-16",
    inputs: [
      {
        className: "grid-cols-1 gap-4",
        inputs: [
          {
            label: "Net",
            name: "invoiceTotals.net",
            type: "text-currency",
            disabled: true,
          },
          {
            label: "Balance",
            name: "invoiceTotals.balance",
            type: "text-currency",
            disabled: true,
            postIcon:
              balance30Days || balance60Days ? (
                <EyeIcon
                  className={`h-4 w-4 cursor-pointer text-gray-400`}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                />
              ) : null,
          },
        ],
      },
      {
        className: "grid-cols-1 gap-4",
        inputs: [
          {
            label: "Tax",
            name: "invoiceTotals.tax",
            type: "text-currency",
            disabled: true,
          },
          {
            label: "Date Updated",
            name: "updatedAt",
            type: "date",
            disabled: true,
          },
        ],
      },
      {
        className: "grid-cols-1 gap-4",
        inputs: [
          {
            label: "Total",
            name: "invoiceTotals.total",
            type: "text-currency",
            disabled: true,
          },
        ],
      },
      {
        className: "grid-cols-1 gap-4",
        inputs: [
          {
            label: "Gross Profit",
            name: "invoiceTotals.grossProfit",
            type: "text-currency",
            disabled: true,
          },
        ],
      },
    ],
  };

  const detailInputProps = {
    formik,
    ...inputs,
  };

  return (
    <div className="mt-4 w-full py-5 lg:min-w-[300px]">
      <h5 className="font-bold">Totals</h5>
      <GridInputs {...detailInputProps} />
      {showTooltip &&
        createPortal(
          <div
            className="pointer-events-none fixed z-50 rounded-md border border-green-500 bg-white shadow-xl"
            style={{
              top: tooltipPos.top,
              left: tooltipPos.left,
              borderRadius: "0.3rem",
            }}
          >
            {balance30Days && (
              <div className="text-md rounded px-2 py-1 font-medium">
                30 Days:{" "}
                {formatCurrency(balance30Days, formik?.values?.currency?.code)}
              </div>
            )}
            {balance60Days && (
              <div className="text-md rounded px-2 py-1 font-medium">
                60 Days:{" "}
                {formatCurrency(balance60Days, formik?.values?.currency?.code)}
              </div>
            )}
          </div>,
          document.body,
        )}
    </div>
  );
};

export default Total;
